/**
 * This barrel file provides the export for the lazy loaded AboutComponent.
 */
export * from './sec.component';
export * from './sec.routes';



// WEBPACK FOOTER //
// ./src/app/sec/index.ts